import { useTranslation } from "react-i18next";

import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import DrmReportAndFilters from "../tmt/DrmReportAndFilters";

import "./DrmtReports.sass";


function DrmtReports() {
  const { t } = useTranslation();
  
  return (
    <Grid container className="drmtReportContainer">
      <Grid item xs={12}>
        <Stack spacing={2} width="100%" px={2}>
          <Stack alignItems="flex-start" width="100%">
            <Typography variant="h4" gutterBottom>
              {t("drmt_report")}
            </Typography>
          </Stack>
          <Stack width="100%">
            <DrmReportAndFilters />
          </Stack>
        </Stack>
      </Grid>
    </Grid>
  );
}

export default DrmtReports;